export default "__VITE_ASSET__UcITy_i5__"